export default __webpack_public_path__ + "03fc6168a59b86408fe5d224a8c9c972.jpg";